<template>
  <div class="mobile-account-cancellation-container">
    <mbHeader :title="$t('account_cancellation')" :left="true" :lang="true"></mbHeader>
    <accountCancellation></accountCancellation>
  </div>
</template>

<script>
import accountCancellation from "../Profile/accountCancellation";
import mbHeader from "../../components/mobile/mbHeader";

export default {
  name: "mobileAccountCancellation",
  components: {accountCancellation, mbHeader},
}
</script>

<style lang="less" scoped>
.mobile-account-cancellation-container {
  min-height: 100vh;
  padding: 50px 0;
  background-color: rgba(0, 0, 0, 0.02);
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileAccountCancellation.vue